import zhCH from "./i18n/interface/zh-CN.js"
import zhTW from "./i18n/interface/zh-TW.js"

const textmap = {
    "zh-TW": zhTW,
    "zh-CN": zhCH
}
const translator = {
    languages: [
        {
            text: "English",
            value: "en"
        },
        {
            text: "繁體中文",
            value: "zh-TW"
        },
        {
            text: "简体中文",
            value: "zh-CN"
        }

    ],
    texts: {},
    currentLang: "en",
    translate: function (text) {
        if (this.currentLang === "en"){
            return text
        }
        return this.texts[text] ? this.texts[text] : text
    },
    setup: function () {
        let storedLang = localStorage.getItem('currentLang')
        if (!storedLang || this.languages.filter(x => x.value === storedLang).length === 0) {
            storedLang = "en"
            localStorage.setItem('currentLang', "en")
        }
        this.currentLang = storedLang
        if (storedLang !== "en") {
            this.texts = textmap[storedLang]
        }
    }
}


export default translator
